export const typesForDownload = {
    xls:'application/vnd.ms-excel',
    xlsx:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pdf:'application/pdf'
};

export const typesForShow = ["pdf","png","jpg","jpeg","xlsx","xls"]